import { ClientInfoForUserAdd } from './../../../_models/user';
import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { SelectedUserClientToAdd } from './../../../_models/admin/selected-user-client-to-add.model';
import { UserClient } from '../../../_models/admin/user-client.model';

@Component({
    selector: 'add-client-row',
    templateUrl: './add-client-row.component.html',
    styleUrls: ['./add-client-row.component.css'],
    standalone: false
})
export class AddClientRowComponent implements OnInit, OnChanges {
  
  @Input() clientList: Array<ClientInfoForUserAdd> = new Array<ClientInfoForUserAdd>();
  @Input() existingClients: Array<UserClient> = new Array<UserClient>();
  @Input() isCustomStripedRow: boolean = false;
  @Output() addCancelled: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() addClient: EventEmitter<SelectedUserClientToAdd> = new EventEmitter<SelectedUserClientToAdd>();

  public addClientRowForm: UntypedFormGroup;
  public clientToAdd: SelectedUserClientToAdd = new SelectedUserClientToAdd();
  public showValidationError: boolean = false;
  public validationError: string = "";

  public filteredClientList: Array<ClientInfoForUserAdd> = new Array<ClientInfoForUserAdd>();

  constructor(
    private formBuilder: UntypedFormBuilder
    ) {
    this.addClientRowForm = this.formBuilder.group({
      selectedClient : [null, [Validators.required]]
    });
  }

  ngOnInit() {
    this.filteredClientList = this.clientList;
  }

  ngOnChanges(): void {
    this.filteredClientList = this.clientList;
  }

  public assignClientRole(event: any, roleType: string): void {
    
    switch (roleType) {
      case "REPORT":
        this.clientToAdd.isReport = event.checked;
        if (!event.checked) {
          this.clientToAdd.viewReferralsOnly = false;
        }
        break;
      case "ADMIN":
        this.clientToAdd.isAdmin = event.checked;
        break;
      case "CUSTODIAN":
        this.clientToAdd.isCustodian = event.checked;
        break;
      case "REFERRAL":
        this.clientToAdd.viewReferralsOnly = event.checked;
        break;
    
      default:
        break;
    }
  }

  public cancel():void {
    this.addCancelled.emit(true);
    this.resetComponent();
  }

  public add():void {
    if (this.validateForm()) {
      let selectedClient = this.addClientRowForm.value.selectedClient
      this.clientToAdd.clientName = selectedClient.clientName;
      this.clientToAdd.clientId = selectedClient.clientId;

      this.addClient.emit(this.clientToAdd);
      this.resetComponent(); 
    }
  }

  private validateForm():boolean {
    if (!this.addClientRowForm.valid) {
      this.validationError = "Please select a client";
      this.showValidationError = true;
      return false;
    } else if (!this.clientToAdd.isAdmin && !this.clientToAdd.isReport && !this.clientToAdd.viewReferralsOnly && !this.clientToAdd.isCustodian) {
      this.validationError = "Please select at least one role";
      this.showValidationError = true;
      return false;
    } else if (this.existingClients && this.existingClients.filter(e => e.clientId == this.addClientRowForm.get("selectedClient").value.clientId).length > 0) {
      this.validationError = "This client has already been added";
      this.showValidationError = true;
      return false;
    }
    return true;
  }

  private resetComponent(): void {
    this.clientToAdd = new SelectedUserClientToAdd(); 
    this.validationError = "";
    this.showValidationError = false;
    this.addClientRowForm.reset();
  }

}
